$('body').on('initScripts pageTransitionComplete', function() {
    // insert dropdown icons in masthead menu
    $('.masthead__nav .menu > .menu-item-has-children > a').each(function() {
        if ($(this).find('.menu-item__dropdown-arrow').length > 0) return false;

        $(this).append('<span class="menu-item__dropdown-arrow"><i class="far fa-chevron-down"></i></span>');
    })
});
